import { render } from "./DebtRepayment.vue?vue&type=template&id=2214e11d"
import script from "./DebtRepayment.vue?vue&type=script&lang=js"
export * from "./DebtRepayment.vue?vue&type=script&lang=js"

import "./DebtRepayment.vue?vue&type=style&index=0&id=2214e11d&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__